module.exports = __webpack_public_path__ + "img/details-ico.f7ff89c5.png";